import { render, staticRenderFns } from "./ModalWarehouseReceptions.vue?vue&type=template&id=3b045755&lang=pug&"
import script from "./ModalWarehouseReceptions.vue?vue&type=script&lang=js&"
export * from "./ModalWarehouseReceptions.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarehouseReceptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports